<!--
 * @Author: zhangjingqing
 * @Date: 2022-05-06 11:03:07
 * @LastEditors: zhangjinqing
 * @LastEditTime: 2022-06-04 17:52:29
 * @Description: file content
 * @FilePath: \lcdp-front-web\src\views\templateManage\Index.vue
-->
<template>
  <div class="container">
    <a-row :gutter="20">
      <a-col :span="12">
        <div class="wrapper">
          <a-spin :spinning="loading" class="tree">
            <a-tree
              show-icon
              :blockNode="true"
              :tree-data="treeData"
              :expandedKeys.sync="expandedKeys"
              :replaceFields="{
                children: 'children',
                title: 'menuName',
                key: 'id',
                value: 'id',
              }"
              @select="onSelect"
            >
              <template slot="custom" slot-scope="item">
                <div class="node">
                  <span class="node-title"
                    ><a-icon
                      type="folder-open"
                      v-if="expandedKeys.includes(item.id) && item.type != -4"
                    />
                    <a-icon type="file-excel" v-else-if="item.type == -4" />
                    <a-icon type="folder" v-else />
                    {{ item.menuName }}
                  </span>
                  <span class="icon-wrap" v-if="item.type == -4">
                    <a-tooltip>
                      <template slot="title">删除</template>
                      <a-icon type="delete" @click="handleDelete(item)" />
                    </a-tooltip>
                  </span>
                  <!-- <span class="icon-wrap" v-if="item.type == 5">
                  <a-tooltip>
                    <template slot="title">编辑</template>
                    <a-icon type="form" @click="handleEdit(item)" />
                  </a-tooltip>
                </span> -->
                  <span class="icon-wrap" v-if="item.type == 5">
                    <a-tooltip>
                      <template slot="title">添加Excel模板</template>
                      <a-icon type="plus" @click="handleAdd(item)" />
                    </a-tooltip>
                  </span>
                </div>
              </template>
            </a-tree>
          </a-spin>
        </div>
      </a-col>
      <a-col :span="12">
        <a-card title="Excel模板详情" :bordered="false" v-if="detailVisible">
          <a slot="extra" href="#"><a-icon type="question-circle" /></a>
          <a-descriptions title="所属目录" :column="4">
            <a-descriptions-item label="年份">{{
              cataInfo.year
            }}</a-descriptions-item>
            <a-descriptions-item label="纳税人类型">{{
              cataInfo.taxpayer
            }}</a-descriptions-item>
            <a-descriptions-item label="指标准则类型">{{
              cataInfo.type
            }}</a-descriptions-item>
            <a-descriptions-item label="时间类型">{{
              cataInfo.dateType
            }}</a-descriptions-item>
            <a-descriptions-item label="对应excel">{{
              cataInfo.excel
            }}</a-descriptions-item>
            <a-descriptions-item label="模板名称">{{
              cataInfo.sheet
            }}</a-descriptions-item>
          </a-descriptions>
        </a-card>
        <div class="empty" v-else>
          <a-empty />
        </div>
      </a-col>
    </a-row>
    <RuleModal ref="ruleModal" @reload="queryList"></RuleModal>
  </div>
</template>
<script>
import { queryAllCatalogmenu } from "@/api/cata";
import RuleModal from "./RuleModal.vue";
import { getParents } from "@/utils/utils";
import { delTmp } from "@/api/template";
export default {
  name: "",
  components: { RuleModal },
  data() {
    return {
      loading: false,
      cataInfo: {},
      treeData: [],
      expandedKeys: [],
      detailVisible: false,
    };
  },
  mounted() {
    this.queryList(1);
  },
  methods: {
    async queryList(initial) {
      this.loading = true;
      let res = await queryAllCatalogmenu({
        category: 5,
      });
      if (res.status == 200) {
        if (initial == 1) {
          this.expandedKeys = [];
        }
        let data = res.data;
        this.travelTree(data, initial);
        this.treeData = data;
      } else {
        let msg = res.msg || res.message;
        let len = msg.length;
        this.$notification.error({
          message: "系统提示",
          description: len > 100 ? "系统错误，请联系管理员" : msg,
          duration: 4,
        });
      }
      this.loading = false;
    },
    handleAdd(item) {
      let pid = item.id;
      let sort = item.children ? item.children.length + 1 : 1;
      this.$refs.ruleModal.show(2, pid, getParents(this.treeData, pid), sort);
    },
    handleEdit() {
      this.$refs.ruleModal.show(3);
    },
    handleDelete(record) {
      const that = this;
      this.$confirm({
        title: "确认删除",
        content: "是否删除当前数据?",
        onOk: async function () {
          let res = await delTmp({ id: record.id, detailId: record.detailId });
          if (res.status == 200) {
            that.$message.success("删除成功！");
            that.queryList();
          } else {
            that.$notification.error({
              message: "系统提示",
              description: res.msg || res.message,
              duration: 4,
            });
          }
        },
      });
    },
    async onSelect(keys, event) {
      let node = event.node.dataRef;
      if (node.type == -4) {
        let parents = getParents(this.treeData, node.id);
        this.cataInfo = {
          year: parents[5].menuName,
          taxpayer: parents[4].menuName,
          type: parents[3].menuName,
          dateType: parents[2].menuName,
          excel: parents[1].menuName,
          sheet: parents[0].menuName,
        };
        this.detailVisible = true;
      } else {
        this.detailVisible = false;
      }
    },
    travelTree(datas, initial) {
      for (var i in datas) {
        let node = datas[i];
        node.scopedSlots = { title: "custom" };
        if (node.type < 3 && initial == 1) {
          this.expandedKeys.push(node.id);
        } else if (node.type > 5) {
          node.isLeaf = true;
        }
        if (datas[i].children) {
          this.travelTree(datas[i].children, initial);
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.container {
  min-height: 280px;
  .wrapper {
    padding: 20px;
    background: #fff;
    .tree {
      height: 930px;
      overflow-y: auto;
    }
    .node {
      .icon-wrap {
        display: none;
        float: right;
        margin-left: 5px;
      }
      &:hover {
        .icon-wrap {
          display: block;
        }
      }
    }
  }
}
.options {
  padding-bottom: 16px;
}
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 800px;
  background: #fff;
}
</style>
